<template>
    <div>
        <b-form-input
            v-model="query"
            aria-label="Kategori ara"
            placeholder="Tüm kategorilerde ara"
            @input="search"
        />
        <div class="my-1 d-flex flex-wrap">
            <b-button
                size="sm"
                variant="outline-secondary"
                @click="navigate([])"
            >
                Kök kategoriler
            </b-button>
            <b-button
                v-for="(item, index) in trail"
                :key="item.ty_id"
                size="sm"
                variant="link"
                @click="navigate(trail.slice(0, index + 1))"
            >
                / {{ item.name }}
            </b-button>
        </div>
        <b-alert
            :show="!!error"
            variant="danger"
        >
            {{ error }} <b-button
                size="sm"
                @click="load(page)"
            >
                Tekrar dene
            </b-button>
        </b-alert>
        <p
            v-if="loading"
            role="status"
        >
            Kategoriler yükleniyor…
        </p>
        <p v-else-if="!error && !items.length">
            Yerel katalogda kategori bulunamadı.
        </p>
        <ul
            v-else-if="!error"
            class="list-unstyled"
        >
            <li
                v-for="item in items"
                :key="item.ty_id"
                class="d-flex justify-content-between align-items-center border-bottom py-50"
            >
                <span>{{ item.name }}</span>
                <b-button
                    v-if="Number(item.children_count) > 0"
                    size="sm"
                    variant="outline-secondary"
                    @click="navigate([...trail, item])"
                >
                    Alt kategoriler
                </b-button>
                <b-button
                    v-else
                    size="sm"
                    variant="outline-primary"
                    @click="$emit('select', item)"
                >
                    Seç
                </b-button>
            </li>
        </ul>
        <b-pagination
            v-if="total > limit"
            :value="page"
            :total-rows="total"
            :per-page="limit"
            :disabled="loading"
            size="sm"
            @input="load"
        />
    </div>
</template>
<script>
    import {
        BFormInput, BButton, BAlert, BPagination,
    } from 'bootstrap-vue'
    import { errorMessage } from '@/store/v2/trendyol/management'

    export default {
        components: {
            BFormInput, BButton, BAlert, BPagination,
        },
        data: () => ({
            query: '', trail: [], items: [], page: 1, total: 0, limit: 10, loading: false, error: '', version: 0, timer: null,
        }),
        created() { this.load(1) },
        beforeDestroy() { clearTimeout(this.timer); this.version += 1 },
        methods: {
            search() {
                this.trail = []
                this.items = []
                this.total = 0
                this.loading = true
                clearTimeout(this.timer)
                this.version += 1
                this.timer = setTimeout(() => this.load(1), 350)
            },
            navigate(trail) {
                clearTimeout(this.timer)
                this.trail = trail
                this.query = ''
                this.load(1)
            },
            async load(page) {
                this.version += 1
                const { version } = this
                this.loading = true
                this.error = ''
                this.items = []
                this.total = 0
                this.page = page
                const params = { q: this.query, page, limit: this.limit }
                if (!this.query.trim()) params.parent_id = this.trail.length ? this.trail[this.trail.length - 1].ty_id : ''
                try {
                    const result = await this.$store.dispatch('tyManagement/loadCategories', params)
                    if (version !== this.version) return
                    this.items = result.data
                    this.total = result.total
                } catch (error) {
                    if (version === this.version) this.error = errorMessage(error)
                } finally {
                    if (version === this.version) this.loading = false
                }
            },
        },
    }
</script>
